// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__18tpO","head":"Table_head__3GzNy","col":"Table_col__262TP"};